import React, { Component } from 'react';
import { Dialog, InputBase, Button } from '@mui/material';

class App extends Component {
  constructor (props) {
    super(props);
    const { currentData = {} } = props;
    this.state = {
      data: JSON.parse(JSON.stringify(currentData)),
    };
  }

  onTextChange=({ lable = '', text = '' }) => {
    const { data } = this.state;
    data[lable] = text;
    this.setState({ data: { ...data } });
  }

  renderDailog=() => {
    const { data } = this.state;
    const { onDelete, onEdit, onAdd, error = false, currentData = {} } = this.props;
    const isFirstAdd = !currentData.name;
    const canSend = (data.name || '').length > 0 && (data.data1 || '').length > 0;
    const canEdit = !isFirstAdd && (currentData.name === data.name);
    return (
      <div style={{ padding: 12, backgroundColor: '#f2f2f2', borderRadius: 15 }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ width: 80 }}>公司全稱</div>
          <InputBase
            style={{ backgroundColor: '#fff', borderRadius: 8, paddingLeft: 12, height: 44, border: '1px solid gray' }}
            value={data.name || ''}
            onChange={e => this.onTextChange({ lable: 'name', text: e.target.value })}
          />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', marginTop: 24 }}>
          <div style={{ width: 80 }}>持股比例</div>
          <InputBase
            style={{ backgroundColor: '#fff', borderRadius: 8, paddingLeft: 12, height: 44, border: '1px solid gray' }}
            value={data.data1 || ''}
            type='number'
            onChange={e => this.onTextChange({ lable: 'data1', text: e.target.value })}
          />
        </div>
        {error && <div style={{ color: 'red', marginTop: 24 }}>錯誤，姓名已存在</div>}
        <div style={{ display: 'flex', marginTop: 24, justifyContent: 'center' }}>
          <Button onClick={() => canSend ? onAdd(data) : alert('請輸入資料')}>{`新增${isFirstAdd ? '發起人' : '股東'}`}</Button>
          {!isFirstAdd && <Button disabled={!canEdit} onClick={() => canSend ? onEdit(data) : alert('請輸入資料')} color='success'>變更持股比例</Button>}
          {!isFirstAdd && <Button disabled={!canEdit} onClick={onDelete} color='error'>刪除</Button>}
        </div>
      </div>
    );
  }

  render () {
    const { onClose } = this.props;
    return (
      <Dialog open PaperComponent={this.renderDailog} onClose={onClose} />
    );
  }
}

export default App;
